module.exports = __webpack_public_path__ + "media/cameralens.fa960b95.mp4";